import { ReactNode, createContext, useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { IAuthorizationContextType } from "../../global/interfaces/IAuthorizationContextType";
import { useAuthenticationContext } from "../hooks/useAuthenticationContext";
import { useErrorContext } from "../../global/hooks/useErrorContext";


//The authorization context object holds the latest IAuthorizationContextType.
export const AuthorizationContext = createContext<IAuthorizationContextType | undefined>(undefined);

//This component is responsible to manage the customerkey, token and unfiltered roles state and provide it through the application component tree.
export const AuthorizationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [roles, setRoles] = useState<string | undefined>(undefined);
    const { token } = useAuthenticationContext();
    const { setError } = useErrorContext();
    const [loadingAuthorCtx, setLoadingAuthorCtx] = useState<boolean>(true);
    const AUTHORIZATION_URI = process.env.REACT_APP_AUTHORIZATION_CONTROLLER;

    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        setLoadingAuthorCtx(false);
    };

    //Function to fetch authorization data using theAuthorization api endpoint.
    const AuthorizationControllerFetch = async () => {
        const apiAuthorization = `${AUTHORIZATION_URI}?nftoken=${token}`;
        try {
            setLoadingAuthorCtx(true);
            const response = await fetch(apiAuthorization);
            if (!response.ok) {
                console.log('get', response.statusText);
                setLoadingAuthorCtx(false);
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, 1);
            }
            else {
                setRoles(result.Roles);
            }
        } catch (error: any) {
            console.log('get error', error);
            handleError(null, error.status);
        } finally {
            setLoadingAuthorCtx(false);
        }
    };

    useEffect(() => {
        AuthorizationControllerFetch();
    }, []);

    const value = {
        roles
    }

    return (
        <AuthorizationContext.Provider value={value}>
            {loadingAuthorCtx ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="30vh">
                    <CircularProgress />
                </Box>
            ) : (
                children
            )}
        </AuthorizationContext.Provider>
    );
}